export enum ContactType{
  email = 1 //Contact types may be expanded in the future. Currently we only have email.
}
